import { useSelector } from 'react-redux'
import { selectCurrentToken } from "../features/auth/authSlice"
import jwtDecode from 'jwt-decode'

const LEAD_ASSESSOR = 'Lead Assessor'
const ASSESSOR = 'Assessor'

const useAuth = () => {
    const token = useSelector(selectCurrentToken)
    let isManager = false
    let isAdmin = false
    let isInstaller = false
    let isLeadAssessor = false
    let isAssessor = false
    let status = "Employee"
    let userId = ''
    let roles = []

    if (token) {
        try {
            const decoded = jwtDecode(token)
            const { username, roles: userRoles, id } = decoded.UserInfo || {}
            roles = userRoles || []
            isManager = roles.includes('Manager')
            isAdmin = roles.includes('Admin')
            isInstaller = roles.includes('Installer')
            isLeadAssessor = roles.includes(LEAD_ASSESSOR)
            isAssessor = roles.includes(ASSESSOR)
            userId = id || ''

            if (isInstaller) status = "Installer"
            if (isManager) status = "Manager"
            if (isAdmin) status = "Admin"

            return { userId, username: username || '', roles, status, isManager, isAdmin, isInstaller, isLeadAssessor, isAssessor }
        } catch (error) {
            if (process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.error('Failed to decode JWT', error)
            }
            // Return safe defaults when token is invalid/corrupt/expired
            isLeadAssessor = false
            isAssessor = false
            return { userId, username: '', roles: [], isManager, isAdmin, isInstaller, isLeadAssessor, isAssessor, status }
        }
    }

    return { userId, username: '', roles: [], isManager, isAdmin: false, isInstaller, isLeadAssessor: false, isAssessor: false, status }
}

export default useAuth